






























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Accident} from "@/read-model/accident";
import GoogleMap from "@/components/GoogleMap.vue";
import {AccidentsModule} from "@/store/accidents";
import {AccidentsGroup} from "@/read-model/AccidentsGroup";
import AccidentsGroupDetails from "@/components/AccidentsGroupDetails.vue";
import {Marker} from "@/components/Marker.ts";
import Sidebar from "@/components/Sidebar.vue";
import About from "@/components/About.vue";
import Switcher from "@/components/Switcher.vue";
import Logo from "@/components/Logo.vue";
import AboutSwitcher from "@/components/AboutSwitcher.vue";
import LeafletMap from "@/components/LeafletMap.vue";
import Legend from "@/components/Legend.vue";

@Component({components: {
    Legend,
    AboutSwitcher,
    Logo,
    Switcher, About, Sidebar, AccidentsGroupDetails, MapComponent: LeafletMap}})
export default class AccidentsMap extends Vue {
  @Prop({
    default: function () {
      return [52.2297, 21.0122]
    }
  }) center!: number[];

  sidebarSize: { width: number; height: number } = { width: 0, height: 0 }
  aboutShown = false

  get viewportOffset() {
    let widthRatio = (this.sidebarSize.width / window.innerWidth)
    if (widthRatio == 1) {
      widthRatio = 0
    }
    let heightRatio = (this.sidebarSize.height / window.innerHeight)
    if (heightRatio == 1) {
      heightRatio = 0
    }
    return {
      leftOffset:  widthRatio * 100,
      bottomOffset: heightRatio * 100}
  }

  get accidents(): Accident[] {
    return AccidentsModule.accidents;
  }

  private displayTragedies = false

  get miracles(): AccidentsGroup[] {
    return AccidentsModule.miracles
  }

  get groups(): AccidentsGroup[] {
    return AccidentsModule.groups
  }

  get markers(): Marker[] {
    return (this.displayTragedies ? this.groups : this.miracles)
      .map((group, groupIndex) => new Marker(group, groupIndex))
  }

  async created() {
    this.aboutShown = localStorage !== undefined && localStorage.getItem('about-shown') === "true"
    await AccidentsModule.load()
  }

  closeAbout(): void {
    this.aboutShown = true
    localStorage.setItem('about-shown', "true")
  }

  openAbout(): void {
    this.aboutShown = false
  }

  get activeGroup(): AccidentsGroup | null {
    return AccidentsModule.activeGroup;
  }

  selectGroup(group: AccidentsGroup): void {
    AccidentsModule.openGroup(group)
    this.closeAbout()
  }

  deselectGroup(): void {
    AccidentsModule.closeGroup()
    this.aboutShown = true
  }
}
